import script from "./HiddenField.vue?vue&type=script&setup=true&lang=ts"
export * from "./HiddenField.vue?vue&type=script&setup=true&lang=ts"

import "./HiddenField.vue?vue&type=style&index=0&id=6cd54a75&lang=css"

const __exports__ = script;

export default __exports__